<template>
	<section class="upload-image-container">
		<div class="upload-prompt" v-show="pricingImages[uniqueIndex] === null">
			<i class="fal fa-cloud-upload"></i>
			<p>Click the upload button below</p>
		</div>

		<div
			class="image-preview"
			v-if="pricingImages[uniqueIndex] !== null"
			:style="{
				backgroundImage: 'url(' + pricingImages[uniqueIndex] + ')',
			}"
		></div>

		<div class="control-bar">
			<div class="upload-button-container">
				<input
					type="file"
					:id="`image-upload-${uniqueIndex}`"
					class="upload-button b360-btn b360-btn--workspace-primary"
					@change="handleImage($event)"
				/>
				<label
					:for="`image-upload-${uniqueIndex}`"
					class="b360-btn b360-btn--workspace-primary"
					>Upload</label
				>
			</div>
			<div
				class="delete-button-container"
				v-show="pricingImages[uniqueIndex] !== null"
			>
				<button class="b360-btn" @click="deleteImage">
					<font-awesome-icon :icon="['far', 'trash-alt']" />
				</button>
			</div>
		</div>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

// TODO: correct the way this component is imported by BbUploadImages.vue
// This component is used by BbUploadImages.vue
// It is imported as BBUploadImageCard (without the s after Image)
// so it does not show up in a search for BBUploadImagesCard
export default {
	name: 'BBUploadImagesCard',
	props: ['uniqueIndex'],
	methods: {
		...mapActions(['updateFlyerImage', 'deleteFlyerImage']),
		handleImage(e) {
			const thisRef = this;
			const reader = new FileReader();
			const file = e.target.files[0];

			reader.addEventListener(
				'load',
				() => {
					thisRef.updateFlyerImage({
						index: parseInt(thisRef.uniqueIndex, 10),
						url: reader.result,
					});
				},
				false,
			);

			if (file) {
				reader.readAsDataURL(file);
			}
		},
		deleteImage() {
			this.deleteFlyerImage({
				index: parseInt(this.uniqueIndex, 10),
			});
		},
	},
	computed: mapState({
		pricingImages: (state) => state.lendwizePricingScenario.flyerImages,
	}),
};
</script>

<style lang="scss" scoped>
.upload-image-container {
	position: relative;
	width: 100%;
	@include rem(height, 284px);
	border: 1px solid #e5e5e5;
	@include rem(border-radius, 5px);
	overflow: hidden;

	.upload-prompt {
		@include rem(padding-top, 73px);
		text-align: center;

		.fa-cloud-upload {
			color: #1e8285;
			font-size: 48px;
		}
	}

	.image-preview {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		@include rem(height, 224px);
		background-color: #fff;
		background-size: cover;
		background-position: center center;
	}

	.control-bar {
		display: flex;
		flex-direction: row;
		position: absolute;
		box-sizing: border-box;
		@include rem(padding, 8px);
		bottom: 0;
		width: 100%;
		@include rem(height, 60px);
		border-top: 1px solid #e5e5e5;
		background-color: #f5f5f5;

		.upload-button-container {
			flex-grow: 1;

			.upload-button {
				width: 0.1px;
				height: 0.1px;
				opacity: 0;
				overflow: hidden;
				position: absolute;
				z-index: -1;
			}

			label {
				box-sizing: border-box;
				text-align: center;
			}
		}

		.delete-button-container {
			box-sizing: border-box;
			@include rem(padding-left, 8px);
			@include rem(width, 50px);
			height: 100%;

			.b360-btn {
				width: 100%;
				border: 1px solid #e5e5e5;
				background-color: #fff;

				.fa-trash-alt {
					color: #ff0000;
				}
			}
		}
	}
}
</style>
